import { useEffect, useState } from 'react';

import { SliderSnippet } from '@netfront/ekardo-content-library';

import { INTRO_SLIDER_DATA } from './IntroSlider.constants';

const IntroSlider = () => {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => setIsMounted(true), []);

  return isMounted ? (
    <div className="c-intro-slider">
      <SliderSnippet slider={INTRO_SLIDER_DATA} />
    </div>
  ) : null;
};

export { IntroSlider };
